module.exports = __webpack_public_path__ + "./images/2c37bbb8210694d0c24436b941c1318f.jpg";